import "../styles/Sign.css";
import { useEffect, useRef } from "react";

const SignInput = ({
  sign,
  signLabel,
  onChange,
  autoComplete,
  placeholder,
  typeInput,
  passwordIcon,
  errCondition,
}) => {
  const componentRef = useRef();

  function handleFocus() {
    componentRef.current.classList.add("active");
  }

  return (
    <>
      <label className="sign-form__label" htmlFor={sign}>
        {signLabel}
      </label>
      <div
        className={`sign-form__input__wrapper ${
          errCondition ? "error-wrapper" : ""
        }`}
        ref={componentRef}
        onFocus={handleFocus}
        onBlur={() => componentRef.current.classList.remove("active")}
      >
        <input
          onChange={onChange}
          className="sign-form__input"
          type={typeInput}
          id={sign}
          autoComplete={autoComplete}
          required
          placeholder={placeholder}
        />
        {passwordIcon}
      </div>
    </>
  );
};

export default SignInput;
